import React, { Component } from "react";

import {
  CButton,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CLabel,
  CInput,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CSpinner,
  CBadge,
  CSwitch
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";

import URL from "../../config/api";
import axios from "../../config/axios";
import { youtubeParser } from "../../utils/string";
import Uploader from "../Uploader/uploader";

class NewTutorialModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      // activity: null,
      available: [
        { value: "P", label: "Plataforma" },
        { value: "L", label: "Livros" },
        { value: "A", label: "Avaliação" }
      ],
      availables: [
        { value: "P", label: "Plataforma" },
        { value: "L", label: "Livros" },
        { value: "A", label: "Avaliação" }
      ],
      name: "",
      path: "",
      youtube: false,
      creating: false
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    if (this.props.edit) {
      this.setState({ loading: true });

      axios
        .get(`${URL.api}content/los/singleView/${this.props.contentId}`, {
          headers: {
            authorization: `Bearer ${this.props.user.token}`
          }
        })
        .then(
          resp => {
            if (resp.data.success) {
              this.setState(state => ({
                available: state.availables.filter(item =>
                  resp.data.data.tag.includes(item.value)
                ),
                name: resp.data.data.name,
                path: resp.data.data.path,
                youtube: resp.data.data.path
                  .toLowerCase()
                  .includes("youtube.com"),
                loading: false
              }));
            }
          },
          error => {
            this.error("Não foi possível obter as informações");
          }
        );
    }
  }

  enviar(value) {
    this.setState({ creating: true });

    let obj = {
      loggedUser: this.props.user.user.id,
      name: this.state.name,
      type_id: this.props.type === "manual" ? 29 : 30,
      path: this.state.youtube
        ? `https://www.youtube.com/embed/${youtubeParser(this.state.path)}`
        : this.state.path,
      ability_id: null,
      module_id: null,
      released: true,
      private: false,
      flash: false,
      user_id: this.props.user.user.id,
      skin_id: 1,
      tag: this.state.available.map(item => item.value).join(),
      resume: "",
      objective: "",
      image: "",
      author: "Educandus",
      language_id: 1,
      status: "Liberado",
      year: new Date().getFullYear(),
      source_id: 1,
      difficulty_level_id: 1,
      series: null,
      printable: false
    };

    if (!obj.name) {
      toastr.error("Falha", "Favor preencher o nome do tutorial.");
      this.setState({ creating: false });
      return;
    }

    if (!this.state.path) {
      toastr.error(
        "Falha",
        "Favor fazer o envio do arquivo no início da página."
      );
      this.setState({ creating: false });
    } else {
      axios
        .post(`${URL.api}content/los/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            if (resp.data.success) {
              this.props.onSave({ ...obj, id: resp.data.data });
              this.setState({ creating: false });
            } else {
              this.error("Não foi possível inserir o tutorial");
              this.setState({ creating: false });
            }
          },
          error => {
            this.error("Não foi possível inserir o tutorial");
            this.setState({ creating: false });
          }
        );
    }
  }

  atualizar(value) {
    this.setState({ creating: true });

    let obj = {
      name: this.state.name,
      path: this.state.youtube
        ? `https://www.youtube.com/embed/${youtubeParser(this.state.path)}`
        : this.state.path,
      tag: this.state.available.map(item => item.value).join()
    };

    if (!obj.name) {
      toastr.error("Falha", "Favor preencher o nome do tutorial.");
      this.setState({ creating: false });
      return;
    }

    if (!this.state.path) {
      toastr.error(
        "Falha",
        "Favor fazer o envio do arquivo no início da página."
      );
      this.setState({ creating: false });
    } else {
      axios
        .post(`${URL.api}content/los/update/${this.props.contentId}`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            if (resp.data.success) {
              this.props.onSave({ ...obj, id: resp.data.data });
              this.setState({ creating: false });
            } else {
              this.error("Não foi possível atualizar o tutorial");
              this.setState({ creating: false });
            }
          },
          error => {
            this.error("Não foi possível atualizar o tutorial");
            this.setState({ creating: false });
          }
        );
    }
  }

  done(uploads) {
    this.setState(() => ({
      // image: URL.img + uploads[0]
    }));
  }

  done2(uploads2) {
    this.setState(() => ({
      path: URL.img + uploads2[0]
    }));
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        size="lg"
        centered
        style={{ overflow: "visible" }}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>
            Adicionar {this.props.type === "manual" ? "manual" : "vídeo"}
          </CModalTitle>
        </CModalHeader>
        <CModalBody style={{ overflow: "visible" }}>
          {this.state.loading ? (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center p-4">
              <CSpinner size="md" color="secondary" />
            </div>
          ) : (
            <>
              <CLabel className="d-flex align-items-center mb-2">
                {this.state.youtube ? "Link" : "Arquivo"} do{" "}
                {this.props.type === "manual" ? "manual" : "vídeo"}
                {this.state.path && (
                  <CBadge
                    color="primary"
                    className="ml-2 text-ellipsis"
                    href={this.state.path}
                    target="_blank"
                  >
                    Abrir
                  </CBadge>
                )}
                {this.props.type === "video" && (
                  <div className="flex-1 d-flex justify-content-end align-items-center">
                    <span className="small text-muted mr-2">
                      Vídeo do youtube
                    </span>
                    <CSwitch
                      shape="pill"
                      color="primary"
                      size="sm"
                      checked={this.state.youtube}
                      onChange={e =>
                        this.setState({ youtube: e.target.checked, path: "" })
                      }
                    />
                  </div>
                )}
              </CLabel>
              {this.state.youtube ? (
                <CInputGroup className="mb-3">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-play-circle"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="text"
                    placeholder="Link do vídeo do youtube"
                    value={this.state.path}
                    onChange={e => this.setState({ path: e.target.value })}
                  ></CInput>
                </CInputGroup>
              ) : (
                <Uploader
                  type="lo"
                  maxFiles={1}
                  allowMultiple
                  labelIdle='Arraste e solte seu arquivo ou <span class="filepond--label-action">procure</span>'
                  done={uploads2 => this.done2(uploads2)}
                  acceptedFileTypes={
                    this.props.type === "manual"
                      ? ["application/pdf"]
                      : ["video/*"]
                  }
                />
              )}
              <CFormGroup>
                <CLabel>Nome</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    placeholder="Nome"
                    value={this.state.name}
                    onChange={e => this.setState({ name: e.target.value })}
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Disponível para</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    isMulti
                    placeholder="Disponível para"
                    name="Disponível para"
                    options={this.state.availables}
                    value={this.state.available}
                    className="basic-multi-select flex-1"
                    classNamePrefix="select"
                    onChange={e => this.setState({ available: e })}
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup className="d-flex justify-content-end mb-0">
                <CButton
                  color="primary"
                  className="d-flex justify-content-center align-items-center"
                  onClick={() =>
                    this.props.edit ? this.atualizar() : this.enviar()
                  }
                  disabled={this.state.creating}
                >
                  <>
                    <span style={this.state.creating ? { opacity: 0 } : null}>
                      Salvar
                    </span>
                    {this.state.creating && (
                      <CSpinner
                        size="sm"
                        color="white"
                        style={{ position: "absolute" }}
                      />
                    )}
                  </>
                </CButton>
              </CFormGroup>
            </>
          )}
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({ user: state.user });

export default connect(mapStateToProps, null)(NewTutorialModal);
